var Handlebars = require("../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n        <button data-role=\"save\" title=\""
    + container.escapeExpression(((helper = (helper = helpers.saveBtn || (depth0 != null ? depth0.saveBtn : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"saveBtn","hash":{},"data":data}) : helper)))
    + "\"\r\n                type=\"button\" class=\"pull-right btn btn-floating fx-background-color-primary-color\" aria-label=\"Left Align\">\r\n            <span class=\"glyphicon glyphicon-ok\" aria-hidden=\"true\"></span>\r\n        </button>\r\n    </div>\r\n    <div id=\"fx-data-management-utility-holder\" ></div>\r\n</div>\r\n\r\n<hr>\r\n<div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n       <div data-role=\"data\"></div>\r\n    </div>\r\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/html/data.hbs
// module id = 58
// module chunks = 0